import { addResizeListener, removeResizeListener } from 'element-ui/src/utils/resize-event';

// 设置表格高度
const doResize = async (el, binding, vnode) => {
  // 获取表格Dom对象
  let { componentInstance: $table } = await vnode;
  if (!$table) $table = vnode.children[0].componentInstance;
  if (!$table) return;
  // 获取调用传递过来的数据
  const { value } = binding;
  if (!$table.height) {
    // 不设置高度，滚动将失效
    throw new Error(`el-table must set the height. Such as height='100px'`);
  }
  // 获取距底部距离（用于展示页码等信息）
  const bottomOffset = (value && value.bottomOffset) || 0;
  const paginationHeight = value?.pagination ? 60 : 0;
  // 总高度（用于自定义高度）
  const maxHeight = window.innerHeight;
  // 获取距离顶部的高度
  const topOffset = (value && value.topOffset) || el.getBoundingClientRect().top;
  // 计算列表高度并设置
  let height = maxHeight - topOffset - paginationHeight - bottomOffset;
  height = height < 200 ? 200 : height;
  $table.layout.setHeight(height);
  $table.doLayout();
};

export default {
  // 初始化设置
  bind(el, binding, vnode) {
    // 设置resize监听方法
    el.resizeListener = async () => {
      await doResize(el, binding, vnode);
    };
    // 绑定监听方法到addResizeListener
    addResizeListener(window.document.body, el.resizeListener);
  },
  // 绑定默认高度
  async inserted(el, binding, vnode) {
    await doResize(el, binding, vnode);
  },
  async update(el, binding, vnode) {
    await doResize(el, binding, vnode);
  },
  // 销毁时设置
  unbind(el) {
    // 移除resize监听
    removeResizeListener(el, el.resizeListener);
  },
};
